import { getLogoHeaderUrl } from '@lemontaps/lib/business-logic/features/profile/getter';
import { ImageSettings } from '@/components/Profile/components/ImageSettings';
import { useTranslation } from 'react-i18next';
import { ProfileEditProps } from '@/components/Profile/types';
import { AccountImageState } from '@lemontaps/lib/types/api';

type Props = ProfileEditProps['logoImageEditProps'];

export default function EditLogo({
  account,
  profileDesign,
  editRightAllowed,
  onUpdateByFile,
  onUpdateByUrl,
  onResetToDefault,
}: Props) {
  const { t } = useTranslation();
  const logoHeaderUrlToDisplay = getLogoHeaderUrl(account, profileDesign);

  return (
    <ImageSettings
      disallowed={!editRightAllowed}
      currentUrl={getLogoHeaderUrl(account, profileDesign)}
      imageState={account.logoHeaderState as AccountImageState}
      defaultImageState={profileDesign.logoHeaderState}
      isButton={!logoHeaderUrlToDisplay}
      buttonText={t('addLogo') as string}
      options={profileDesign.logoImgOptions}
      onUploadByFile={onUpdateByFile}
      onUploadByUrl={onUpdateByUrl}
      onResetToDefault={onResetToDefault}
      onDelete={onResetToDefault}
      ariaLabel={(!logoHeaderUrlToDisplay ? t('addLogo') : t('editLogo')) as string}
    />
  );
}
